import styled from 'styled-components'

const Box = styled.div`
  width: 100%;
  position: relative;
  height: 12px;
`

const Bar = styled.div`
  width: 100%;
  background-color: var(--color-bg-sidebar);
  border-radius: 12px;
  height: 100%;
`

const Track = styled.div`
  width: ${p => p.width}%;
  height: 100%;
  background-color: ${p => !!p.isOverdue ? 'var(--color-error)' : 'var(--color-primary)'};
  box-shadow: ${p => !!p.isOverdue ? '0 6px 16px 0 rgba(255,65,64,0.3)' : '0 6px 16px 0 rgba(151,202,111,0.3)'};
  border-radius: 12px;
  position: absolute;
  top: 0;
  left: 0;
  transition: width 0.3s ease;
`

const Progress = ({ percent, isOverdue }) => {

  return (
    <Box>
      <Bar />
      <Track isOverdue={isOverdue} width={isOverdue ? 100 : percent} />
    </Box>
  )
}

export default Progress
